<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="500">
        <v-card>
            <v-card-title id="heading" class="d-flex justify-space-between">
                <h4>{{ company.company_name }}'s Billing Exemption</h4>
                <v-btn density="compact" :disabled="saving" icon="mdi-close" variant="flat" @click="close"/>
            </v-card-title>

            <v-card-text>
                <v-alert class="mb-4" density="compact" type="warning" variant="tonal">
                    An exempt company is never invoiced and never suspended for non-payment, and
                    gets top tier features regardless of its plan.
                </v-alert>

                <v-switch v-model="exempt" color="warning" density="compact" hide-details
                          :label="exempt ? 'Billing exempt' : 'Not billing exempt'"/>

                <v-textarea v-if="exempt" v-model="reason" class="mt-4" counter="255" label="Reason"
                            maxlength="255" rows="3" :rules="[v => !!v || 'Reason is required']"/>
            </v-card-text>
            <v-card-actions class="px-4">
                <v-btn :disabled="saving" variant="text" @click="close">Cancel</v-btn>
                <v-spacer/>
                <v-btn color="warning" :disabled="saving || (exempt && !reason.trim())" :loading="saving"
                       @click="submit">Submit</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
import {ref} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";

const props = defineProps({
    modelValue: Boolean,
    company: Object
});
const {showSnackbar} = useSnackbarStore();
const dialogSwitch = ref(props.modelValue);
const exempt = ref(!!props.company.billing_exempt);
const reason = ref('');
const saving = ref(false);

const emits = defineEmits([
    'update:modelValue',
    'updateBillingExemption'
])

const close = () => {
    emits('update:modelValue', false);
}

const submit = () => {
    const action = exempt.value ? 'exempt from billing' : 'no longer exempt from billing';
    if (!confirm(`Are you sure to make "${props.company.company_name}" ${action}?`)) {
        return;
    }

    saving.value = true;
    send('put', `companies/${props.company.id}/billing-exemption`, {
        exempt: exempt.value,
        reason: exempt.value ? reason.value.trim() : null
    })
        .then((response) => {
            if (response.data.success) {
                emits('updateBillingExemption', {
                    company_id: props.company.id,
                    billing_exempt: response.data.data.billing_exempt
                });
                emits('update:modelValue', false);
                showSnackbar(response.data.message);
            }
        })
        .catch((error) => {
            console.log(error)
            showSnackbar(error.response?.data?.message
                ?? `"${props.company.company_name}" billing exemption could not be updated`, 'error')
        })
        .finally(() => {
            saving.value = false;
        })
}
</script>
